export const interactionTypes = [
  'CRN_Doctor_Directory_Update',
  'CRN_Doctor_Directory_Add',
  'CRN_Doctor_Directory_Remove'
];